import { SET_STRUCTURE, SET_UNITS_LIST, SET_EDIT_UNIT_NAME, SET_EDIT_UNIT_SETTINGS, SET_EDIT_EMPLOYEES_LIST, SET_EDIT_SUB_UNITS_LIST, SET_EDIT_SUPERVISORS_LIST } from "./types";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getStructure = (ouID = null) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/structure${ouID ? `/unit/${ouID}` : ``}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_STRUCTURE, payload: response.data.structure });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getAllUnits = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/structure/all`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_UNITS_LIST, payload: response.data.units });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getSubordinateUnits = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/structure/subordinate`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_UNITS_LIST, payload: response.data.subordinate });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const setOuName = () => async (dispatch) => dispatch({ type: SET_EDIT_UNIT_NAME, payload: null });

export const getOuName = ouID => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/structure/unit/name/${ouID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_EDIT_UNIT_NAME, payload: response.data.name });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getOuSettings = (ouID, onSuccess) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/structure/unit/settings/${ouID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_EDIT_UNIT_SETTINGS, payload: response.data.settings });
            onSuccess();
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getOuEmployees = (ouID = null, type = SET_EDIT_EMPLOYEES_LIST) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/structure/edit/employees${ouID ? `/${ouID}` : ``}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type, payload: response.data.employees });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getOuSubUnits = (ouID = null) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/structure/edit/sub-units${ouID ? `/${ouID}` : ``}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_EDIT_SUB_UNITS_LIST, payload: response.data.subUnits });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getOuSupervisors = ouID => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/structure/edit/supervisors/${ouID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_EDIT_SUPERVISORS_LIST, payload: response.data.supervisors });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const editOuSettings = (ouID, formValues, onSuccess) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/structure/edit/settings/${ouID}`, { ...formValues }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) onSuccess();
    }
    catch (error) { errorHandler(error, null); }
};

export const editOuEmployees = (ouID, formValues, onSuccess) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/structure/edit/employees${ouID ? `/${ouID}` : ``}`, { ...formValues }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_EDIT_EMPLOYEES_LIST, payload: response.data.employees });
            onSuccess();
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const editOuSubUnits = (ouID, formValues, onSuccess, onFieldError) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/structure/edit/sub-units${ouID ? `/${ouID}` : ``}`, { ...formValues }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_EDIT_SUB_UNITS_LIST, payload: response.data.subUnits });
            onSuccess();
        };
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const editOuSupervisors = (ouID, formValues, onSuccess, onFieldError) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/structure/edit/supervisors/${ouID}`, { ...formValues }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_EDIT_SUPERVISORS_LIST, payload: response.data.supervisors });
            onSuccess();
        };
    }
    catch (error) { errorHandler(error, onFieldError); }
};